<script setup lang="ts">
import Typography from '@components/Typography.vue';
import Button from '@components/Button.vue';
import { storeToRefs } from 'pinia';
import { useSearchStore } from '@stores/useSearchStore.ts';
import SearchOfferCard from '@pages/search/components/SearchOfferCard.vue';
import SearchListSkeleton from '@pages/search/components/SearchListSkeleton.vue';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { watch } from 'vue';
import { transchoice } from '@tools/translation.ts';

const searchStore = useSearchStore();
const {
  offers,
  nbOffers,
  nbSpaces,
  isLoading,
  mapIsVisible,
} = storeToRefs(searchStore);
const { openMap, closeMap } = searchStore;

const { isMobileOrTablet } = storeToRefs(useScreensizeStore());

watch(isMobileOrTablet, () => {
  if (isMobileOrTablet.value) {
    closeMap();
  }
});
</script>

<template>
  <div
    :class="[
      mapIsVisible ? 'lg:max-w-[384px] xl:max-w-[830px]' : 'max-w-screen-xl',
      'mx-auto w-full',
    ]"
  >
    <div class="flex items-center justify-between">
      <Typography
        v-if="!isLoading"
        :variant="isMobileOrTablet ? 'small-title-tag' : 'content-heading-2'"
        color="gray-darker"
      >
        {{ transchoice('search.summary.count', { offers_count: nbOffers, spaces_count: nbSpaces }) }}
      </Typography>

      <div class="flex gap-x-2">
        <div>
          @todo Tri : Recommendations
        </div>

        <Button
          v-if="!mapIsVisible && !isMobileOrTablet"
          variant="secondary"
          @click="openMap"
        >
          Carte
        </Button>
      </div>
    </div>

    <div
      :class="[
        mapIsVisible ? 'max-w-[830px]' : 'max-w-screen-xl',
        'mx-auto lg:ml-0',
      ]"
    >
      <SearchListSkeleton v-if="isLoading" />

      <ul
        v-else
        :class="[
          'p-0',
          'grid grid-cols-1 gap-6',
          mapIsVisible ? 'xl:grid-cols-2' : 'min-[634px]:grid-cols-2 lg:grid-cols-3',
        ]"
      >
        <li
          v-for="offer in offers"
          :key="offer.hash_id"
          class="list-none"
        >
          <SearchOfferCard :offer="offer" />
        </li>
      </ul>
    </div>
  </div>
</template>
